import React, { useEffect, useState } from "react";
import GameCard from "./GameCard";
import api from "../utils/api";

const UpcomingReleases = () => {
  const [games, setGames] = useState([]);

  useEffect(() => {
    api.get('/upcomingreleases')
      .then((response) => {
        const currentDate = new Date();
        // Set time to start of day for accurate date comparison
        currentDate.setHours(0, 0, 0, 0);

        const parsedGames = response.data
          .filter(game => {
            // Convert Unix timestamp to Date object and set to start of day
            const releaseDate = new Date(game.first_release_date * 1000);
            releaseDate.setHours(0, 0, 0, 0);
            // Include games released today or in the future
            return releaseDate >= currentDate;
          })
          .slice(0, 8) // Limit to first 8 games
          .map((game) => ({
            id: game.id,
            title: game.name,
            releaseDateUnix: game.first_release_date,
            releaseDate: new Date(game.first_release_date * 1000).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              timeZone: 'UTC'
            }),
            cover: game.coverUrl || "/StockGameCover.jpg",
            summary: game.storyline || "No synopsis available.",
            trailerUrl: game.trailerUrl
              ? game.trailerUrl.replace("watch?v=", "embed/")
              : null,
          }));
        setGames(parsedGames);
      })
      .catch((error) => {
        console.error("Failed to load games:", error);
      });
  }, []);

  return (
    <section className="bg-gradient-to-br from-white to-blue-50 text-gray-900 py-20 px-6">
      <h2 className="text-4xl font-extrabold text-center text-blue-600 mb-12">
        Upcoming Releases
      </h2>
      {games.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 justify-items-center max-w-7xl mx-auto">
          {games.map((game, index) => (
            <GameCard 
              key={index} 
              game={game} 
              variant="light" 
              showRating={false}
            />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600">
          <p>No upcoming releases at the moment.</p>
        </div>
      )}
    </section>
  );
};

export default UpcomingReleases;
